import { VStack, ScrollView, Heading, Text, Link } from 'native-base';

export function PrivacyPolicy() {
  const AppName = 'Musicont'
  return (
    <VStack
      flex={1}
    >
      <ScrollView
        _contentContainerStyle={{
          px: "20px",
          mb: "4",
          minW: "72"
        }}
      >
        <Heading
          margin={1.5}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title1'
          fontFamily='Title1Bold'
          lineHeight='Title1'
          letterSpacing='Title1'
        >
          {`Políticas de Uso e de Privacidade`}
        </Heading>
        <Text
          margin={1.5}
          textAlign='center'
          color='Label.Select'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >
          {`Atualizado em 08/11/2023`}
        </Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`Por este instrumento eletrônico é informado as POLÍTICAS do aplicativo ${AppName}, conforme as disposições abaixo discriminadas:`}
        </Text>
        <Heading
          margin={1.5}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title2'
          fontFamily='Title2Bold'
          lineHeight='Title2'
          letterSpacing='Title2'
        >
          {`Políticas de Uso`}
        </Heading>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`Ao baixar ou usar o aplicativo ${AppName}, as políticas, os termos de uso e condições que contam nesta página, se aplicarão automaticamente, portanto, certifique-se de lê-los atentamente antes de usar o aplicativo.`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`O aplicativo móvel ${AppName} é um aplicativo GRATUÍTO que oferece os seus serviços SEM CUSTO. E distina-se que seus usuários o usem sem intenções monetárias.`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`O Usuário do aplicativo móvel ${AppName} não tem permissão para:
        - copiar ou modificar o aplicativo, em qualquer parte do aplicativo;
        - utilizar as marcas, logotipo, identificações próprias e outros direitos de propriedade intelectual de forma alguma;
        - extrair o código-fonte do aplicativo;
        - traduzir o aplicativo para outros idiomas ou fazer versões derivadas;`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`O Desenvolvedor está empenhado em garantir que o aplicativo seja o mais útil e eficiente possível. Então ele tem o direito de fazer alterações no aplicativo, a qualquer momento e por qualquer motivo.`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`É de responsabilidade do Usuário manter o seu telefone celular em bom estado e em segurança. O Desenvolvedor recomenda que o Usuário não faça o Jailbreak ou Root no seu telefone, que é o processo de remoção de restrições e limitações de software impostas pelo sistema operacional oficial do seu dispositivo. Isso pode tornar seu telefone vulnerável a malware/vírus/programas maliciosos, comprometer os recursos de segurança do seu telefone e pode significar que o aplicativo ${AppName} não funcione corretamente.`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`O Usuário precisa garantir que seu dispositivo permaneça carregado, se ficar sem bateria e não puder ligá-lo para aproveitar os serviços fornecidos pelo aplicativo, o Desenvolvedor não poderá ser responsabilizado.`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`O Usuário deve estar ciente de que há certas coisas pelas quais o Desenvolvedor não se responsabiliza. Certas funções do aplicativo exigirão que o aplicativo tenha uma conexão ativa com a Internet. A conexão pode ser Wi-Fi ou fornecida pelo seu provedor de rede móvel, mas o Desenvolvedor não pode se responsabilizar pelo aplicativo não funcionar em plena funcionalidade se o Usuário não tiver acesso a internet. Se o Usuário estiver usando o aplicativo fora de uma área com Wi-Fi, lembre-se de que os termos do contrato com seu provedor de rede móvel ainda se aplicam. Como resultado, o Usuário pode ser cobrado pela sua operadora de celular pelo custo dos dados trafegados durante a conexão e acesso ao aplicativo ou outras cobranças de terceiros. Ao usar o aplicativo, o Usuário aceita a responsabilidade por tais cobranças, incluindo cobranças de dados de roaming se o Usuário usar o aplicativo fora de seu território de origem (ou seja, região ou país).`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`Em algum momento, o Desenvolvedor irá atualizar o aplicativo. O aplicativo poderá estar disponível para os sistemas operacionais Android e iOS – os requisitos para ambos os sistemas (e para quaisquer sistemas adicionais para os quais estender a disponibilidade do aplicativo) podem mudar, e o Usuário precisará baixar as atualizações se quiser manter usando o aplicativo. O Desenvolvedor não promete que sempre atualizará o aplicativo de forma que funcione em uma versão específica de um determinado sistema operacional que o Usuário instalou no seu dispositivo. No entanto, o Usuário tem que sempre aceitar as atualizações do aplicativo quando oferecidas. Também existe a possibilidade do Desenvolvedor querer ou ser obrigado a parar de fornecer o aplicativo,  podendo rescindir o uso dele a qualquer momento sem aviso de rescisão ao Usuário. A menos que o Desenvolvedor diga o contrário, após qualquer rescisão, os direitos e licenças concedidos ao Usuários nestes termos terminarão. Após a rescisão o Usuário deve parar de usar o aplicativo e excluí-lo do seu dispositivo.`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`Quando o Usuário estiver usando o aplicativo, é importante ter em mente que, embora o Desenvolvedor se esforce para garantir que o aplicativo esteja atualizado e correto o tempo todo, o Desenvolvedor depende de terceiros que são responsáveis por fornecer as informações disponibilizadas. Então o Desenvolvedor não se responsabiliza por qualquer perda, direta ou indireta, que o Usuário experimente como resultado de confiar totalmente nos serviços e informações fornecidas pelo aplicativo.`}</Text>
        <Heading
          margin={1.5}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title2'
          fontFamily='Title2Bold'
          lineHeight='Title2'
          letterSpacing='Title2'
        >
          {`Política de Privacidade: Noções Básicas`}
        </Heading>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`Este instrumento traz a política de privacidade dos serviços prestados através do aplicativo móvel ${AppName}, mostrando a forma como os dados e informações serão administradas.`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`Esta política de privacidade visa garantir que quaisquer informações e dados não serão fornecidos, publicados ou comercializados em quaisquer circunstâncias. E esta página é usada para informar os Usuários sobre as políticas de Coleta, Uso e Divulgação de Informações Pessoais. Se o Usuário optou por usar o Aplicativo ${AppName}, concorda com a coleta e uso de informações que consta nesta política de privacidade.`}</Text>
        <Heading
          margin={1.5}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title2'
          fontFamily='Title2Bold'
          lineHeight='Title2'
          letterSpacing='Title2'
        >{`Política de Privacidade: Coleta e uso de Dados`}
        </Heading>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`Esta aplicação não armazena, nenhum dado direto ou indireto relacionado a identificação e localização do Usuário do aplicativo.`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`As informações usadas neste aplicativo são armazenadas em um banco de dados com acesso restrito, que é gerenciado pela plataforma online da Google Firebase. Para o bom funcionamento do aplicativo é utilizado serviços, bibliotecas, ferramentas ou frameworks de terceiros que podem coletar informações para o bom funcionamento do aplicativo. Abaixo temos a Politica de Privacidade de nossos principais fornecedores de serviços, bibliotecas, ferramentas, frameworks etc:`}</Text>
        <Text>{'      '}<Link
            href="https://google.com/policies/privacy"
            isExternal _text={{
              color: "Label.Tinted"
            }} mt={-0.5} _web={{
              mb: -2
            }}
          >{`- Clique aqui para a Política de Privacidade do Google;`}</Link></Text>
          <Text>{'      '}<Link
            href="https://firebase.google.com/support/privacy"
            isExternal _text={{
              color: "Label.Tinted"
            }} mt={-0.5} _web={{
              mb: -2
            }}
          >{`- Clique aqui para a Política de Privacidade do Firebase;`}</Link></Text>
          <Text>{'      '}<Link
            href="https://expo.io/privacy"
            isExternal _text={{
              color: "Label.Tinted"
            }} mt={-0.5} _web={{
              mb: -2
            }}
          >{`- Clique aqui para a Política de Privacidade do Expo;`}</Link></Text>
          <Text>{'      '}<Link
            href="https://nativebase.io/privacy-policy"
            isExternal _text={{
              color: "Label.Tinted"
            }} mt={-0.5} _web={{
              mb: -2
            }}
          >{`- Clique aqui para a Política de Privacidade do NativeBase.`}</Link></Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`Estes terceiros podem ter que acessar informações para a realização de tarefas atribuídas a eles. No entanto, eles são obrigados a não divulgar ou usar as informações para qualquer outra finalidade.`}</Text>
        <Heading
          margin={1.5}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title2'
          fontFamily='Title2Bold'
          lineHeight='Title2'
          letterSpacing='Title2'
        >
          {`Política de Privacidade: Cookies`}
        </Heading>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`Cookies são arquivos com uma pequena quantidade de dados que são comumente usados como identificadores exclusivos anônimos. O aplicativo não usa esses “cookies” explicitamente. No entanto, o aplicativo pode usar código de terceiros e bibliotecas que usam “cookies” para coletar informações.`}</Text>
        <Heading
          margin={1.5}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title2'
          fontFamily='Title2Bold'
          lineHeight='Title2'
          letterSpacing='Title2'
        >
          {`Política de Privacidade: Segurança`}
        </Heading>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`O desenvolvedor deste aplicativo valoriza a sua confiança e está se esforçando para usar meios legalmente aceitáveis na segurança no aplicativo. Mas lembre-se que não existe aplicativo que utilize a internet, 100% seguro e confiável, sendo impossível garantir a segurança absoluta.`}</Text>
        <Heading
          margin={1.5}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title2'
          fontFamily='Title2Bold'
          lineHeight='Title2'
          letterSpacing='Title2'
        >
          {`Política de Privacidade: Links`}
        </Heading>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`Este Aplicativo pode conter links para outros sites. Se você clicar em um link de terceiros, será direcionado para esse site. Observe que estes sites externos não são operados pelo Desenvolvedor. Portanto, é aconselhável ao Usuário rever a Política de Privacidade desses sites. O desenvolvedor não  tem controle e não assume responsabilidade pelo conteúdo, políticas de privacidade ou práticas de quaisquer sites ou serviços de terceiros.`}</Text>
        <Heading
          margin={1.5}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title2'
          fontFamily='Title2Bold'
          lineHeight='Title2'
          letterSpacing='Title2'
        >
          {`Política de Privacidade: Menores de Idade`}
        </Heading>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`Este Aplicativo não se dirige a menores de idade. Não há coleta intencionalmente de informações de identificação pessoal de menores de idade. Se o Usuário é o pai ou o responsável e está ciente de que seu filho usou o aplicativo e forneceu alguma informações pessoal, entre em contato para que se possa tomar as medidas necessárias para exclusão de tal informação.`}</Text>
        <Heading
          margin={1.5}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title2'
          fontFamily='Title2Bold'
          lineHeight='Title2'
          letterSpacing='Title2'
        >
          {`Alterações de Políticas`}
        </Heading>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`O Desenvolvedor tem o total direito de atualizar as políticas a qualquer momento. Assim, recomenda-se que o Usuário revise esta página periodicamente para quaisquer alterações.`}</Text>
        <Heading
          margin={2}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title3'
          fontFamily='Title3Bold'
          lineHeight='Title3'
          letterSpacing='Title3'
        >
          {`Qualquer dúvida, sugestão ou correção entre em contato:`}
        </Heading>
        <Heading
          textAlign='center'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyBold'
          lineHeight='Body'
          letterSpacing='Body'
        >{`Felipe Sineider Martins\nDesenvolvedor\nsineider@gmail.com`}
        </Heading>
      </ScrollView>
    </VStack>
  );
}